

const Templecontent = () =>{
    return (
        
                      <div className="container mt-4">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="saptitle erptitle">What is Temple ERP?</div>
                <p className="erppara"> 
                Temple Management Software is used to simplify the management of all temple-related activities. Our software provides comprehensive features to help you manage temple membership, donations, events, accounting and more. Our user-friendly interface allows you to access all the information you need to manage your temple efficiently. 
                </p>
                <ul className="websub erpul">
	<li className="webpoints">Our software is also cloud-based, which means you can operate it from anywhere at any time. </li>
    <li className="webpoints">Our scalable and customizable Software for Temple Management allows you to tailor it to your specific requirements. </li>
                </ul>
                
                    </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <img src="https://www.geniusedusoft.com/assets/img/temple-icon15.png" alt="erp" className="img-erp img-shadow" />
                </div>
            </div>
        </div>
 
        
    )
}

export default Templecontent